import PriceTagView from './price-tag-view'

export default PriceTagView
